// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-14a7b6ce] {\n  display: flex;\n  justify-content: space-between;\n}\n.noData[data-v-14a7b6ce] {\n  text-align: center;\n  padding: 30px 0;\n  color: #333;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
